/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmModelsUpdateCatalogEntry } from "../../funcs/llmModelsUpdateCatalogEntry.js";
import * as components from "../../models/components/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: components.UpdateCatalogModelRequest$inboundSchema,
};

export const tool$llmModelsUpdateCatalogEntry: ToolDefinition<typeof args> = {
  name: "llm-models-update-catalog-entry",
  description: `Update a BYO catalog model

Updates an API-owned BYO definition; yaml-origin entries are file-managed and immutable through this API.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmModelsUpdateCatalogEntry(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
